import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  ManageReceiptTemplatesRootParamList,
  ReceiptTemplateFormParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ReceiptTemplateFormScreen } from "./ReceiptTemplateFormScreen";
import React from "react";
import { ReceiptTemplateForm } from "../../components/ReceiptTemplateForm";
import { SelectTemplateStyleScreen } from "./SelectTemplateStyleScreen";

const Stack = createStackHeaderNavigator<ReceiptTemplateFormParamList>();

export type CreateReceiptTemplateScreenProps = NativeStackScreenProps<
  ManageReceiptTemplatesRootParamList,
  "CreateReceiptTemplateScreen"
>;

export const CreateReceiptTemplateScreen = ({
  navigation,
  route,
}: CreateReceiptTemplateScreenProps) => {
  return (
    <ReceiptTemplateForm>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerBackgroundContainerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Stack.Group>
          <Stack.Screen
            name="ReceiptTemplateFormScreen"
            component={ReceiptTemplateFormScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            presentation: "modal",
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <Stack.Screen
            name="SelectTemplateStyleScreen"
            component={SelectTemplateStyleScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ReceiptTemplateForm>
  );
};
